class EventTracker {
    endpoint = "/api/events-managment-service/event/v1/add" // event-service end point
    initialData = {
      eventBaseURL: "",
      channel: "",
      msisdn: "",
      xCountry: "",
      header: {}
    }
  
    // Private constructor to prevent direct instantiation
    constructor() {}
  
    // Static method to get an instance, if needed
    static getInstance() {
      if (!this.instance) {
        this.instance = new EventTracker()
      }
      return this.instance
    }
  
    /**
     *
     * @param token If user is authorised this argument will consist authorization token otherwise will be empty
     * @returns the header option values to passed in request header
     */
    getHeaderOptions = () => {
      const headers = {
        "Content-Type": "application/json",
        deviceName: "web",
        msisdn: this.initialData.msisdn || "",
        channel: this.initialData.channel,
        "x-country": this.initialData.xCountry,
        buildNo: 1,
        ...this.initialData.header
      }

      return headers
    }
  
    /**
     * Saves event data to the server.
     * @param eventData - The data to be saved.
     */
    saveEventData(eventData, token="") {
      try {
        fetch(
          `${this.initialData.eventBaseURL}${this.endpoint}`,
          {
            method: "POST",
            headers: {
              ...this.getHeaderOptions()
            },
            body: JSON.stringify({ events: [eventData] })
          }
        )
          .then(response => response.json())
          .then(data => {})
          .catch(error => console.error("Error saving event:", error))
      } catch (error) {
        console.error("Synchronous error while saving event data:", error)
      }
    }
  
    /**
     * Sends the event data to be saved.
     * @param eventProps - Event data properties to be saved.
     */
    send(eventProps) {
      try {
        const { eventType, timeStamp, token, msisdn = "", userDevice = {}, ...rest } = eventProps
          let eventObj = {
            eventType: eventType,
            channel: this.initialData.channel,
            timeStamp: timeStamp,
            loggedIn: Boolean(token),
            msisdn: msisdn,
            userDevice: userDevice,
            meta: { ...rest, token: token || "" }
          }

          if (msisdn) {
            eventObj = { ...eventObj, meta: { ...eventObj.meta, msisdn }}
            if(this.initialData.msisdn !== msisdn) {
              this.initialData.msisdn = msisdn
            }
          }
          // Save the event data
          this.saveEventData(eventObj, token)
      } catch (error) {
        console.error("Error sending event:", error)
      }
    }

    /**
     * Initializes the tracker with configuration.
     * @param initProps - Initialization properties for the tracker.
     */
    initialize(initProps) {
      try {
        this.initialData = { ...initProps }
      } catch (error) {
        console.error("Error initializing event tracker:", error)
      }
    }
  }

  const init = () => {
    try {
      return EventTracker.getInstance();
    } catch (error) {
      console.error("Error creating event tracker instance:", error)
    }
  }
  
  // Created single instance at the module level
  window.eventTrackerInit = init;
 